import React, { FC, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import SportsGymnasticsIcon from "@mui/icons-material/SportsGymnastics";

export interface StartRegisterProps {
  className?: string;
}

const StartRegister: FC<StartRegisterProps> = ({ className = "" }) => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null);

  const handleOptionSelect = (option: string) => {
    setSelectedOption(option);
  };

  const isCreateAccountDisabled = !selectedOption;

  return (
    <div
      className={`nc-PageCollection ${className}`}
      data-nc-id="PageCollection"
    >
      <Helmet>
        <title>Sanolink</title>
      </Helmet>

      <Container
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #dedede",
          borderRadius: "8px",
          width: "100%", // Make the container full width
          maxWidth: "700px", // Set max width
          marginBottom: "2rem",
          marginTop: "2rem",
          gap: "20px",
        }}
      >
        <Typography
          variant="h5"
          sx={{ fontWeight: "bold", mb: 4, textAlign: "center" }}
        >
          Register as a user or Fit Mentor
        </Typography>

        <Box
          justifyContent="center"
          alignItems="center"
          display={"flex"}
          flexDirection={{ xs: "column", sm: "row" }} // Change direction for small screens
          gap={{ xs: 4, sm: 7 }}
        >
          <Grid item xs={12} sm={6}>
            <Button
              component="a"
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #dedede",
                borderRadius: "8px",
                bg: selectedOption === "user" ? "sky.200" : "transparent",
                cursor: "pointer",
                transition: "background-color 0.15s ease-in",
                width: "100%", // Make the button full width
                maxWidth: "240px", // Set max width
                height: "150px",
                textAlign: "left",
                color: "#000",
                p: 3,
                gap: "10px",
              }}
              onClick={() => handleOptionSelect("/signup")}
            >
              <Box
                display={"flex"}
                width={"100%"}
                marginBottom={"0.5rem"}
                justifyContent={"space-between"}
              >
                <AccessibilityIcon sx={{ fontSize: 40, mr: 2 }} />
                <Checkbox
                  checked={selectedOption === "/signup"}
                  onChange={() => handleOptionSelect("/signup")}
                  sx={{ borderRadius: "100%", width: "20px", height: "20px" }}
                />
              </Box>

              <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>
                I'm a person, wanting to improve myself
              </Typography>
            </Button>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Button
              component="a"
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                border: "1px solid #dedede",
                borderRadius: "8px",
                bg: selectedOption === "fitMentor" ? "sky.200" : "transparent",
                cursor: "pointer",
                transition: "background-color 0.15s ease-in",
                width: "100%", // Make the button full width
                maxWidth: "240px", // Set max width
                height: "150px",
                textAlign: "left",
                color: "#000",
                p: 3,
                gap: "10px",
              }}
              onClick={() => handleOptionSelect("/fit-memeber-registration")}
            >
              <Box
                display={"flex"}
                width={"100%"}
                marginBottom={"0.5rem"}
                justifyContent={"space-between"}
              >
                <SportsGymnasticsIcon sx={{ fontSize: 40, mr: 2 }} />
                <Checkbox
                  checked={selectedOption === "/fit-memeber-registration"}
                  onChange={() =>
                    handleOptionSelect("/fit-memeber-registration")
                  }
                  sx={{ borderRadius: "100%", width: "20px", height: "20px" }}
                />
              </Box>

              <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>
                I'm a FitMentor, wanting to help others improve
              </Typography>
            </Button>
          </Grid>
        </Box>

        <Box sx={{ marginTop: "2rem" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#4bc265",
              color: "white",
              borderRadius: 8,
              mt: 2,
              textTransform: "capitalize",
              width: "100%", // Make the button full width
              maxWidth: "300px", // Set max width
              "&:hover": {
                backgroundColor: "#4bc265",
              },
            }}
            href={`${selectedOption}`}
            disabled={isCreateAccountDisabled}
          >
            Create Account
          </Button>
          <Typography
            sx={{ marginTop: "1.5rem", textAlign: "center", fontSize: "13px" }}
          >
            Already have an account? <Link href="/login">Log In</Link>
          </Typography>
        </Box>
      </Container>
    </div>
  );
};

export default StartRegister;
